import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid, Backdrop, CircularProgress, Snackbar } from "@material-ui/core";
import { properties as AppData } from "AppData";
import { Alert } from "@material-ui/lab";
import Confirmacion from 'components/commons/Confirmacion/Confirmacion';
import ComponenteGenericoFormio from "components/commons/componenteGenericoFormio/componenteGenericoFormio";
import { texts, objComponentFormio, properties } from "./RestaurarContrasenaData";
import useFunctions from "./RestaurarContrasenaFunctions";
import useStyles from "./RestaurarContrasenaStyle";
import 'BootstrapWrapper.scss';

export default function RestaurarContrasena(props) {
  const { style } = useStyles();
  const customStyle = style();
  
  const {
    handleOnSubmit,
    handleCustomEvents,
    isLoading,
    alerts,
    message,
    setMessage,
    irAccesoConContrasena,
    mostrarConfirmacion,
    setResetToken
  } = useFunctions();

  // Analiza la ubicación actual para obtener el valor del token
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');

  useEffect(() => {
    setResetToken(token)
  }, []);

  // Se inserta el nombre del título de la página
  document.title = AppData.TITULO_PAGINA + texts.PAGE_TITLE;

  return (
    <main>
      {/** El nombre de esta clase, tiene que coincidir con el nombre de la clase que se encuentra en el fichero BootstrapWrapper.scss */}
      <Grid className="componenteGenericoFormio">
        <Grid className={customStyle.gridTitulo}>
          <h2 className={customStyle.tituloPagina}>{texts.PAGE_TITLE}</h2>
        </Grid>
        <Grid className={customStyle.backgroundRectangle}>
          <ComponenteGenericoFormio
            {...objComponentFormio}
            onSubmit={handleOnSubmit}
            onCustomEvent={handleCustomEvents}
          />
        </Grid>
      </Grid>
      <Backdrop className={customStyle.classBackdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {alerts.map((m) => (
        <Snackbar
          key = "snackbar"
          open={message.msg}
          autoHideDuration={5000}
          onClose={() => setMessage({ severity: "", msg: "" })}
        >
          <Alert severity={message.severity} variant="filled">
            {message.msg}
          </Alert>
        </Snackbar>
      ))}
      
      <Confirmacion 
        mostrar={mostrarConfirmacion} isPhoneVersion={false}
        titulo={texts.confirmacion.titulo}
        mensaje={texts.confirmacion.mensaje}
        botonera='confirSoloAceptar'
        accionConfirmacion={irAccesoConContrasena}
        tamMarginTop='10'
        isPopUpPdf={false}
        textBotonConfirmarPersonalizado={false}
        isImagenPersonalizada={true}
        centrarContenido={true}
        imagen={properties.IMAGEN_OK}
        isTextoEnriquecido={true}
      />
    </main>
  );
}
